'use client'
import React from 'react';
import { Direction } from './utils';
import SvgIcon from '../layout/svg-icons/svg-icons'

interface IProps {
  hasPrev: boolean;
  hasNext: boolean;
  onClickPrev?: () => void;
  onClickNext?: () => void;
  isPrevDisabled?: boolean;
  isNextDisabled?: boolean;
}

export const StepNavigation: React.FC<IProps> = ({ hasNext, hasPrev, onClickNext, onClickPrev, isNextDisabled, isPrevDisabled }) => {

  const arrow = (<SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M15.913 8.45783C15.9995 8.23906 16.0222 7.99833 15.978 7.76609C15.9339 7.53386 15.8249 7.32055 15.665 7.15317L11.0933 2.36541C10.9878 2.25109 10.8617 2.15991 10.7223 2.09718C10.5828 2.03445 10.4329 2.00143 10.2811 2.00005C10.1294 1.99866 9.97885 2.02895 9.83839 2.08913C9.69793 2.14931 9.57032 2.23819 9.463 2.35057C9.35569 2.46296 9.27083 2.5966 9.21336 2.7437C9.15589 2.8908 9.12697 3.04841 9.12829 3.20734C9.12961 3.36627 9.16114 3.52333 9.22104 3.66936C9.28094 3.81539 9.36801 3.94747 9.47717 4.05788L12.0991 6.80366H1.14293C0.839806 6.80366 0.549097 6.92977 0.334756 7.15423C0.120416 7.3787 0 7.68315 0 8.0006C0 8.31805 0.120416 8.62249 0.334756 8.84696C0.549097 9.07143 0.839806 9.19754 1.14293 9.19754H12.0991L9.47831 11.9421C9.36915 12.0525 9.28208 12.1846 9.22218 12.3306C9.16228 12.4767 9.13075 12.6337 9.12943 12.7927C9.12811 12.9516 9.15703 13.1092 9.2145 13.2563C9.27197 13.4034 9.35683 13.537 9.46415 13.6494C9.57146 13.7618 9.69907 13.8507 9.83953 13.9109C9.97999 13.9711 10.1305 14.0013 10.2823 14C10.434 13.9986 10.584 13.9656 10.7234 13.9028C10.8629 13.8401 10.989 13.7489 11.0944 13.6346L15.6661 8.84683C15.772 8.7354 15.8559 8.60322 15.913 8.45783Z" fill="white" />
  </SvgIcon>);

  const renderButton = (direction: Direction) => {
    const text = direction === Direction.prev ? 'Back' : 'Next';
    const buttonHandler = direction === Direction.prev ? onClickPrev : onClickNext;
    const isDisabled = direction === Direction.prev ? isPrevDisabled : isNextDisabled;
    return (
      <button
        className={`!text-white flex flex-row items-center justify-center bg-black h-[40px] w-[100px] px-[5px] py-[3px] m-[5px] border-[1px] rounded-[8px] ${isDisabled ?
          'cursor-pointer bg-gray-400' : ''}`}
        onClick={buttonHandler}
        aria-label={text}
      >
        {direction === Direction.prev ? <div className={'mr-1 transform rotate-180'}>{arrow}</div> : null}
        {text}
        {direction === Direction.next ? <div className={`ml-1`}>{arrow}</div> : null}
      </button>
    )
  }
  return (
    <>
      {hasPrev ? renderButton(Direction.prev) : null}
      {hasNext ? renderButton(Direction.next) : null}
    </>
  )
}
